import React from "react";

export const LessonTabControlContext = React.createContext(null);
